import { defineStyleConfig } from '@chakra-ui/react'

export const DividerTheme = defineStyleConfig({
  baseStyle: {
    borderColor: 'gray.300'
  },
})
